/* istanbul ignore file */
import Document from '@tiptap/extension-document'
import Underline from '@tiptap/extension-underline'
import Placeholder from '@tiptap/extension-placeholder'
import Link from '@tiptap/extension-link'
import BulletList from '@tiptap/extension-bullet-list'
import HardBreak from '@tiptap/extension-hard-break'
import Heading from '@tiptap/extension-heading'
import ListItem from '@tiptap/extension-list-item'
import OrderedList from '@tiptap/extension-ordered-list'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'
import Bold from '@tiptap/extension-bold'
import Italic from '@tiptap/extension-italic'
import DropCursor from '@tiptap/extension-dropcursor'
import GapCursor from '@tiptap/extension-gapcursor'
import History from '@tiptap/extension-history'
import CharacterCount from '@tiptap/extension-character-count'
import { LIMIT_CHARS } from '../../tiptap.constants'

export const extensions = [
  Document,
  BulletList,
  HardBreak,
  Heading,
  ListItem,
  OrderedList,
  Paragraph,
  Text,
  Underline,
  Bold,
  Italic,
  DropCursor,
  GapCursor,
  History,
  Placeholder,
  CharacterCount.configure({
    limit: LIMIT_CHARS
  }),
  Link.configure({
    openOnClick: false,
    validate: (href) => /https?:\/\//.test(href),
    HTMLAttributes: {
      rel: 'noopener noreferrer',
      target: '_blank'
    }
  })
]
